<template>
    <!-- LOCATION SEARCH -->
    <Teleport to="body">
        <transition name="fade">
            <div v-show="showLocationSearch" @click="closeLocationSearch" id="locationBG" @keydown.esc="closeLocationSearch"
                class="bg-gray-200/80 dark:bg-neutral-900/75 backdrop-blur-lg z-50 fixed top-0 left-0 h-full w-full py-2 sm:py-4 md:py-8 overflow-y-scroll overflow-x-hidden scrollbar-hide animate-in fade-in ease-in-out duration-800 js_close_clickable">
                <div class="flex mx-2 sm:mx-4 md:mx-8 gap-2">
                    <div @click="closeLocationSearch"
                        class="bg-white md:hidden h-full p-4 border border-gray-300 rounded-md flex justify-center items-center animate-in zoom-in fade-in ease-in-out duration-300 js_close_clickable">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="w-6 h-6 pointer-events-none"
                            viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                            <path
                                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
                        </svg>
                    </div>
                    <div
                        class="bg-white w-full border border-gray-300 md:h-[81px] rounded-md flex justify-end md:pl-6 items-center animate-in zoom-in fade-in ease-in-out duration-300 relative">
                        <input type="text" ref="location" @input="askForData" @keydown.esc="closeLocationSearch"
                            :placeholder="listingType ? listingType+'...' : $t('Locations') + '...'" tabindex="0" v-model="searchLocationName"
                            class="w-full h-full text-xl md:text-3xl text-start font-bold  border-transparent bg-transparent focus:border-transparent focus:ring-0">
                        <div v-if="searchLocationName"
                            class="px-2 h-full flex items-center group cursor-pointer animate-in fade-in absolute right-14 bg-white/50"
                            @click="clearInput">
                            <div
                                class="p-4 flex items-center justify-center group-hover:bg-gray-200 rounded-full transition duration-300 group-hover:scale-95 group-active:scale-75">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                    viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                    <path
                                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                </svg>
                            </div>
                        </div>
                        <div class="px-2 pr-4 h-full flex items-center group cursor-pointer absolute right-0 bg-white/50"
                            @click="(e) => e.target.blur()">
                            <div
                                class="p-4 flex items-center justify-center group-hover:bg-gray-200 rounded-full transition duration-300 group-hover:scale-95 group-active:scale-75">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                    viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                    <path
                                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                </svg>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="w-full px-4 md:px-8 flex justify-end  js_close_clickable">
                    <button type="button" @click="switchToCalendar"
                        class="text-gray-500 mt-5 mb-4 md:mb-0 group font-medium text-sm px-4 rounded-full duration-500 ease-in-out py-2.5 mr-auto ml-auto sm:mr-0 text-center inline-flex items-center transition cursor-pointer hover:bg-white">
                        {{ $t('See all') }} {{ listingType }}
                        <svg class="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 14 10">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M1 5h12m0 0L9 1m4 4L9 9" />
                        </svg>
                    </button>
                </div>

                <div v-show="loading" class="duration-500 ease-in-out sm:-mt-16  js_close_clickable dark:text-white">
                    <h2
                        class="font-bold text-xl sm:text-3xl mt-4 md:mt-8 mb-4 px-4 md:px-8 js_close_clickable dark:text-white">
                        {{ $t('Searching') }}...</h2>
                    <div
                        class="flex gap-4 max-w-full snap-x scroll-pl-8 snap-proximity overflow-x-scroll scrollbar-hide animate-in fade-in animate-out slide-out-from-left ease-out duration-800 fade-in px-4 md:px-8">
                        <div v-for="n in 10"
                            class="flex flex-col gap-4 animate-in fade-in animate-out slide-out-from-left fade-out snap-start transition cursor-pointer group">
                            <div
                                class="flex items-center justify-center h-[160px] w-[160px] sm:h-[200px] sm:w-[200px] bg-white dark:bg-neutral-800 animate-pulse rounded-lg">
                                <svg class="w-10 h-10 text-gray-200 dark:text-neutral-500 " aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                    <path
                                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <h2
                        class="font-bold text-3xl mt-8 mb-4 h-[30px] py-3 w-[100px] bg-gray-400 dark:bg-neutral-500 animate-pulse rounded-full mx-8 js_close_clickable">
                    </h2>
                    <div class="flex flex-col md:flex-row gap-4 mb-8 px-4 md:px-8">
                        <div v-for="n in 10" class="flex flex-col gap-4 flex-wrap ">
                            <div
                                class="flex items-center justify-start h-[100px] w-[400px] bg-white dark:bg-neutral-800 animate-pulse rounded-lg px-4">
                                <svg class="w-10 h-10 text-gray-200 dark:text-neutral-500" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                    <path
                                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!loading"
                    class="animate-in fade-in duration-500 ease-in-out sm:-mt-16 js_close_clickable dark:text-white">
                    <h2
                        class="md:block font-bold text-xl sm:text-3xl mt-4 md:mt-8 mb-4 px-4 md:px-8 js_close_clickable dark:text-white">
                        {{ $t('Search Results') }}</h2>
                    <div class="flex gap-4 max-w-full snap-x scroll-pl-8 snap-proximity  animate-in ease-out duration-500 fade-in px-4 md:px-8 js_close_clickable"
                        :class="{ 'overflow-x-scroll scrollbar-hide': accomodations['highMatch'] !== undefined && accomodations['highMatch'].length > 1 }">
                        <div v-if="accomodations['highMatch'] !== undefined && accomodations['highMatch'].length > 1"
                            v-for="(item, _) in accomodations['highMatch']" @click='handleLocationChange($event, item)'
                            class="flex flex-col gap-4 animate-in fade-in snap-start transition cursor-pointer group">
                            <div
                                class="bg-white dark:bg-neutral-800 rounded-lg  h-[160px] w-[160px] sm:h-[200px] sm:w-[200px] flex justify-center items-center shadow-lg  group-hover:shadow-none group-hover:scale-95 transition relative">
                                <likebutton v-if="item.id" :id="item.id"
                                    background="absolute top-3 right-3 bg-black/50 backdrop-blur-sm"
                                    color="text-gray-100"> </likebutton>
                                <object v-if="item.hasOwnProperty('nonHome') & item.nonHome == 'propertyType'"
                                    class="h-10 w-10 pointer-events-none"
                                    v-bind:data="$baseUrl + '/images/icons/propTypes/' + item.name + '.svg'"
                                    :title="item.name"></object>
                                <object v-else-if="item.hasOwnProperty('nonHome')" class="h-10 w-10 pointer-events-none"
                                    v-bind:data="$baseUrl + '/images/icons/' + item.nonHome + '.svg'"
                                    :title="item.nonHome"></object>
                                <img v-else class="w-full h-full object-cover rounded-lg pointer-events-none" loading="lazy"
                                    v-bind:src="mipmap(item.spotlightimage, 400)">
                            </div>
                            <span class="max-w-[160px] sm:max-w-[200px]">{{ item.name }}</span>
                        </div>
                        <div v-else-if="accomodations['highMatch'] !== undefined && accomodations['highMatch'].length == 1"
                            class="max-w-full">
                            <div
                                class="bg-white dark:bg-neutral-800 p-3 rounded-lg w-[700px] max-w-full flex flex-col sm:flex-row justify-start gap-4 items-center cursor-pointer shadow-lg animate-in fade-in relative">
                                <likebutton :id="accomodations['highMatch'][0].id"
                                    background="absolute top-5 right-5 sm:top-3 sm:right-3 bg-black/50 backdrop-blur-sm"
                                    color="text-gray-100"> </likebutton>
                                <img class="w-full sm:w-[300px] h-[150px] sm:h-[300px] object-cover rounded-lg"
                                    @click="handleLocationChange($event, accomodations['highMatch'][0])" loading="lazy"
                                    v-bind:src="mipmap(accomodations['highMatch'][0].spotlightimage, 400)">
                                <div class="flex flex-col gap-4 w-full h-full">
                                    <div class="sm:h-[300px]">
                                        <div class="flex flex-col items-start justify-between h-full">
                                            <div class="flex flex-col h-full justify-center mb-4 sm:mb-0 w-full"
                                                @click="handleLocationChange($event, accomodations['highMatch'][0])">
                                                <span class="text-xl md:text-3xl font-bold">{{
                                                    accomodations['highMatch'][0].name }}</span>
                                                <div class="flex">
                                                    <span class="h-3 w-4 mr-1"
                                                        v-bind:class="'fi fi-' + accomodations['highMatch'][0].country.toLowerCase()"></span>
                                                    <span class="text-sm leading-5">{{
                                                        accomodations['highMatch'][0].city }}</span>
                                                </div>
                                            </div>
                                            <div class="flex w-full gap-2 items-center">
                                                <button @click="handleLocationChange($event, accomodations['highMatch'][0])"
                                                    :title="$t('See availability')"
                                                    class="bg-primary rounded shadow px-5 py-3 text-center w-full text-white hover:scale-95 grow">
                                                    {{ $t('See availability') }}!
                                                </button>
                                                <a :href="$homeUrl + '/accomodations/' + accomodations['highMatch'][0]['id']"
                                                    class="shrink text-gray-600 hover:text-gray-800 hover:scale-95 active:scale-75 duration-300 transition"
                                                    :title="$t('Go to accommodation')">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10"
                                                        fill="currentColor"
                                                        viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                                        <path
                                                            d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="accomodations['mediumMatch'] !== undefined && accomodations['mediumMatch'].length">
                        <h2 class="font-bold text-2xl sm:text-3xl mt-8 mb-4 px-8 js_close_clickable">
                            {{ $t('Also interesting') }}</h2>
                        <div class="flex gap-4 mb-8 max-w-full snap-x scroll-pl-8 snap-proximity animate-in ease-out duration-500 fade-in px-8"
                            :class="{ 'overflow-x-scroll scrollbar-hide': accomodations['mediumMatch'] !== undefined && accomodations['mediumMatch'].length > 1 }">
                            <div v-for="(item, _) in accomodations['mediumMatch']"
                                @click='handleLocationChange($event, item)'
                                class="flex flex-col gap-4 animate-in fade-in snap-start transition cursor-pointer group">
                                <div
                                    class="bg-white rounded-lg h-[150px] w-[150px] flex justify-center items-center shadow-lg  group-hover:shadow-none group-hover:scale-95 transition relative">
                                    <likebutton v-if="item.id" :id="item.id"
                                        background="absolute top-3 right-3 bg-black/50 backdrop-blur-sm"
                                        color="text-gray-100"> </likebutton>
                                    <object v-if="item.hasOwnProperty('nonHome') & item.nonHome == 'propertyType'"
                                        class="h-10 w-10"
                                        v-bind:data="$baseUrl + '/images/icons/propTypes/' + item.name + '.svg'"
                                        :title="item.name"></object>
                                    <object v-else-if="item.hasOwnProperty('nonHome')" class="h-10 w-10"
                                        v-bind:data="$baseUrl + '/images/icons/' + item.nonHome + '.svg'"
                                        :title="item.nonHome"></object>
                                    <img v-else class="w-full h-full object-cover rounded-lg" loading="lazy"
                                        v-bind:src="mipmap(item.spotlightimage, 400)">
                                </div>
                                <span class="max-w-[150px]">{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="accomodations['deals'] !== undefined && accomodations['deals'].length">
                        <h2 class="font-bold text-2xl sm:text-3xl mt-8 mb-4 px-8 js_close_clickable">{{ $t('Related') }} {{
                            $t('Special Offers!') }}
                        </h2>
                        <div class="flex gap-4 snap-x scroll-pl-8 snap-proximity px-8 flex-col sm:flex-row  animate-in ease-out duration-500 fade-in"
                            :class="{ 'overflow-x-scroll scrollbar-hide': accomodations['deals'] !== undefined && accomodations['deals'].length > 1 }">
                            <a v-for="(item, _) in accomodations['deals']"
                                class="flex max-w-full flex-wrap gap-4 animate-in fade-in snap-start transition cursor-pointer group">
                                <div
                                    class="bg-white dark:bg-neutral-800 w-full rounded-lg h-[100px] sm:w-[400px] flex gap-4 justify-start px-6 items-center shadow-lg group-hover:shadow-none group-hover:scale-95 transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="currentColor"
                                        viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                        <path
                                            d="M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z" />
                                    </svg>
                                    <span class="font-bold text-lg sm:text-xl">{{ item.name }}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div v-if="accomodations['news'] !== undefined && accomodations['news'].length">
                        <h2 class="font-bold text-2xl sm:text-3xl mt-8 mb-4 px-8 js_close_clickable">{{ $t('Related') }} {{
                            $t('News') }}</h2>
                        <div class="flex gap-4 snap-x scroll-pl-8 snap-proximity px-8 flex-col sm:flex-row  animate-in ease-out duration-500 fade-in"
                            :class="{ 'overflow-x-scroll scrollbar-hide': accomodations['news'] !== undefined && accomodations['news'].length > 1 }">
                            <a v-for="(item, _) in accomodations['news']" :href="currentUrl + '/news/' + item.slug"
                                class="flex max-w-full flex-wrap gap-4 animate-in fade-in snap-start transition cursor-pointer group">
                                <div
                                    class="bg-white dark:bg-neutral-800 w-full rounded-lg h-[100px] sm:w-[400px] flex gap-4 justify-start px-6 items-center shadow-lg group-hover:shadow-none group-hover:scale-95 transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="currentColor"
                                        viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                        <path
                                            d="M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z" />
                                    </svg>
                                    <span class="font-bold text-lg sm:text-xl">{{ item.title }}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>
  
<script>
const { debounce } = require("lodash");
import VueCookies from 'vue-cookies'

export default {
    data() {
        return {
            accomodations: [],
            showLocationSearch: false,
            searchLocation: null,
            searchLocationName: "",
            currentUrl: "",
            loading: true,
            propName: '',
            location: '',
            listingType: '',
            listing_type_description: '',
            useguests: '',
            search: new URLSearchParams(window.location.search),
            isChrome: /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
        };
    },

    props: {
        cache_acco: '',
    },
    mounted() {
        const clientVars = this.$attrs.clientvariables ? JSON.parse(this.$attrs.clientvariables) : {};

        this.listingType = clientVars['listing_type'].split(',')[0];
        this.listing_type_description = clientVars['listing_type_description'];
        this.useguests = clientVars.useguests == "1" ? true : false;

        this.$root.$on("showLocationSearch", (msg) => {
            this.askForData();
            $("body").addClass("scroll_lock")
            this.showLocationSearch = msg;
        });
    },
    methods: {
        closeLocationSearch(e) {
            if (e.target.classList.contains('js_close_clickable') || e.key == "Escape") {
                this.showLocationSearch = false;
                setTimeout(function () {
                    $("body").removeClass("scroll_lock")
                }, 350);
            }
        },
        mipmap(src, res) {
            if (src) {
                if (src.includes('https://media.xmlcal.com')) {
                    var imgblocks = src.split("/");
                    var imgfile = imgblocks[imgblocks.length - 1];
                    var thumbnailimgsmall =
                        imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
                    imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
                    return imgblocks.join("/");
                } else {
                    return src;
                }
            } else return 0;
        },
        switchToCalendar(e) {
            VueCookies.set('searchlocation', null)
            this.searchlocation = null;
            this.showLocationSearch = false
            this.$root.$emit("locationChange", null);
            this.$root.$emit("showCalendarSearch", true);
        },
        async handleLocationInput() {
            if (this.$refs.location && this.$refs.location.value == "") {
                this.propName = '';
                this.location = '';
                VueCookies.set('location', '')
            }

            this.loading = true;
            this.accomodations = [];
            try {
                let response = await fetch(
                    this.$BMB_API + 'api/' +
                    this.$clientID +
                    "/getSuggestionsDropdown?search=" + this.$refs.location.value,
                    {
                        headers: {
                            "Content-Type": "text/plain",
                        },
                    }
                );
                this.accomodations = await response.json();
                this.loading = false;
            } catch (error) {
                console.log(error);
                this.loading = false;
            }
        },

        fetch: _.debounce(function () {
            this.handleLocationInput()
        }, 1000),
        askForData: function () {
            this.loading = true;
            this.accomodations = [];
            this.fetch();
        },
        handleLocationChange(event, item) {
            VueCookies.set('searchlocation', item)
            this.searchlocation = item;
            this.showLocationSearch = false
            this.$root.$emit("locationChange", item);
            this.$root.$emit("showCalendarSearch", true);
        },
        clearInput() {
            this.searchlocation = null;
            this.searchLocationName = null;
            VueCookies.set('searchlocation', null);
            this.$root.$emit("locationChange", null);
            this.askForData();
        }
    },

    watch: {
        showLocationSearch: {
            handler: function (newValue, oldValue) {
                if (!oldValue && newValue) {
                    setTimeout((location) => {
                        location.focus();
                    }, 100, this.$refs.location);
                }
            }
        },
        searchLocation: {
            handler: function (newValue) {
                this.searchLocationName = newValue.name;
            }
        }
    },

    created() {
        this.currentUrl = this.$attrs.base_url;

        if (VueCookies.get('searchlocation')) {
            this.searchlocation = VueCookies.get('searchlocation')
            this.searchLocationName = this.searchlocation.name;
        }
    },
};
</script>
  